// Ritmo da partida: cada ação dos bots espera os sons e animações da anterior
// terminarem, em vez de tudo se atropelar.
let busyUntil = 0;

/** Reserva `seconds` a partir de agora (soma com o que já estava reservado). */
export function holdFor(seconds: number): void {
  const now = performance.now();
  busyUntil = Math.max(busyUntil, now) + seconds * 1000;
}

/** Quanto falta (ms) para a mesa ficar livre. */
export function busyMs(): number {
  return Math.max(0, busyUntil - performance.now());
}

export function resetPace(): void {
  busyUntil = 0;
}
